import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { buildStackedBarItemTooltipOptions } from "./stackedBarItemTooltip";

export function translateStackedBarResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  return buildStackedBarItemTooltipOptions(
    states,
    states.chartTypeParam?.properties?.y?.dataType
  );
}
